module.exports = __webpack_public_path__ + "img/4abc8ce.jpg";